if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        // Check if viewer exists
        if (!this.elements.viewer) return;
        
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        
        if (activeMedia.classList) {
          activeMedia.classList.add('is-active');
        }

        if (prepend && activeMedia.parentElement) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement) {
              if (activeThumbnail.parentElement.firstChild !== activeThumbnail) {
                activeThumbnail.parentElement.prepend(activeThumbnail);
              }
            }
          }

          if (this.elements.viewer.slider && typeof this.elements.viewer.resetPages === 'function') {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          try {
            if (!this.mql.matches || this.elements.thumbnails) {
              if (activeMedia.parentElement && typeof activeMedia.parentElement.scrollTo === 'function') {
                activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft || 0 });
              }
            }
            
            const activeMediaRect = activeMedia.getBoundingClientRect();
            // Don't scroll if the image is already in view
            if (activeMediaRect.top > -0.5) return;
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          } catch (error) {
            console.error('Error in setActiveMedia timeout:', error);
          }
        });
        
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!activeThumbnail) return;
        
        this.setActiveThumbnail(activeThumbnail);
        
        // Only announce if we have a valid position
        if (activeThumbnail.dataset && activeThumbnail.dataset.mediaPosition) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        if (!activeItem) return;
        
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        
        // Check if liveRegion exists before trying to use it
        if (!this.elements.liveRegion) return;
        
        image.onload = () => {
          try {
            this.elements.liveRegion.setAttribute('aria-hidden', 'false');
            if (window.accessibilityStrings && window.accessibilityStrings.imageAvailable) {
              this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position || '1');
            }
            setTimeout(() => {
              if (this.elements.liveRegion) {
                this.elements.liveRegion.setAttribute('aria-hidden', 'true');
              }
            }, 2000);
          } catch (error) {
            console.error('Error in announceLiveRegion:', error);
          }
        };
        
        // Safely trigger the image load
        try {
          const currentSrc = image.src;
          image.src = currentSrc;
        } catch (error) {
          console.error('Error setting image src:', error);
        }
      }

      playActiveMedia(activeItem) {
        if (!activeItem) return;
        
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }
        
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        try {
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (!this.stickyHeader) return;
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        } catch (error) {
          console.error('Error in preventStickyHeader:', error);
        }
      }

      removeListSemantic() {
        try {
          if (!this.elements.viewer || !this.elements.viewer.slider) return;
          
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          
          if (this.elements.viewer.sliderItems && Array.isArray(this.elements.viewer.sliderItems)) {
            this.elements.viewer.sliderItems.forEach((slide) => {
              if (slide) {
                slide.setAttribute('role', 'presentation');
              }
            });
          }
        } catch (error) {
          console.error('Error in removeListSemantic:', error);
        }
      }
    }
  );
}
